<template>
  <div class="teen-page teen0">
    <div class="header">
      <h1>杂交水稻之父：袁隆平</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_0.png" alt="袁隆平在稻田">
        <div class="caption">袁隆平院士在试验田观察水稻生长情况</div>
      </div>

      <h2>一、 一粒种子改变世界</h2>
      <p>袁隆平（1930-2021），中国杂交水稻育种专家，中国工程院院士。他毕生致力于杂交水稻研究，成功培育出高产杂交水稻品种，被誉为"杂交水稻之父"。他的研究成果让中国用不到世界9%的耕地，养活了世界近20%的人口，为解决全球粮食问题做出了巨大贡献。</p>

      <h2>二、 艰难的探索之路</h2>
      <p>1960年，袁隆平在稻田中发现了一株天然杂交水稻，这激发了他培育杂交水稻的灵感。在那个特殊的年代，他顶着巨大的压力坚持研究。经过无数次失败，终于在1973年实现了三系配套，成功培育出籼型杂交水稻。这项技术使水稻产量大幅提升，创造了巨大的经济效益和社会效益。</p>

      <div class="quote-box">
        "人就像种子，要做一粒好种子。" —— 袁隆平
      </div>

      <h2>三、 禾下乘凉梦</h2>
      <p>袁隆平有两个梦想：一是禾下乘凉梦，梦见试验田的水稻长得像高粱一样高，穗子像扫帚一样长，谷粒像花生米一样大，他和助手们坐在稻穗下乘凉；二是杂交水稻覆盖全球梦，希望杂交水稻能够推广到全世界，帮助更多国家解决粮食问题。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_0.png" alt="金黄的稻田">
        <div class="caption">丰收的稻田，承载着希望与梦想</div>
      </div>

      <h2>四、 永远的丰碑</h2>
      <p>2021年5月22日，袁隆平院士逝世，全国人民深切哀悼。他虽然离开了我们，但他的精神永远激励着后人。他用一生诠释了什么是科学家的责任与担当，他的名字将永远铭刻在人类文明的史册上。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen0'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #fff8f0;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #2d5a27 0%, #4a7c59 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #2d5a27;
  border-bottom: 2px solid #8eb057;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #e8f5e9;
  padding: 20px;
  border-left: 4px solid #2d5a27;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>